/**
 * Marketer View footer (SYR-79).
 *
 * Mirrors the classic ModernDashboardLayout footer: the Privacy Policy / Terms
 * of Service links (shown only when the LEGAL_ACCEPTANCE_ENABLED setting is on,
 * via `useLegalAcceptance().isEnabled`) plus the copyright line. Same intl keys
 * and styling so the two shells read identically.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Typography } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';
import { useAuth } from '../../../hooks/useAuth';
import { useLegalAcceptance } from '../../../hooks/useLegalAcceptance';

const { Text } = Typography;

export const MarketerFooter: React.FunctionComponent = () => {
  const intl = useIntl();
  const { user } = useAuth();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const { isEnabled } = useLegalAcceptance({ jwtToken: user?.jwtToken || null });

  return (
    <footer
      style={{
        textAlign: 'center',
        background: 'transparent',
        padding: isMobile ? '16px' : '24px',
        borderTop: '1px solid #e5e7eb',
      }}
    >
      {isEnabled && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: isMobile ? '16px' : '24px',
            marginBottom: '8px',
            flexWrap: 'wrap',
          }}
        >
          <Link
            to="/privacy-policy"
            style={{ color: '#6b7280', fontSize: '14px', textDecoration: 'none' }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#F59E0B')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#6b7280')}
          >
            {intl.formatMessage({ id: 'auth.footer.privacyPolicy' })}
          </Link>
          <Link
            to="/terms-of-service"
            style={{ color: '#6b7280', fontSize: '14px', textDecoration: 'none' }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#F59E0B')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#6b7280')}
          >
            {intl.formatMessage({ id: 'auth.footer.termsOfService' })}
          </Link>
        </div>
      )}
      <Text style={{ color: '#9ca3af', fontSize: '12px' }}>
        <FormattedMessage
          id="auth.footer.copyright"
          values={{
            year: new Date().getFullYear(),
            syriant: (chunks: React.ReactNode) => (
              <a
                href="https://syriant.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'inherit', textDecoration: 'underline' }}
              >
                {chunks}
              </a>
            ),
          }}
        />
      </Text>
    </footer>
  );
};
